import { H5, P } from "@/components/ui/typography";
import { ContainerPrimary, ContainerSecondary } from "../ui";
import { useParams } from "react-router-dom";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import {
  useIntegrationMemoActiveCreate,
  useIntegrationMemoActives,
} from "@/api/generate-hpdb";
import { formatDateTime } from "@/utils/helper/formatDate";
import { convertUppercaseLabelToCapitalize } from "../utils/convertUppercaseLabelToCapitalize";
import { SubmitButton } from "@/components/ui/button";
import { swalError, swalSuccess } from "@/utils/lib/swal";
import { useEffect } from "react";

export function CreateMemoHandler({
  isReadOnly,
  onStatusChange,
}: {
  isReadOnly: boolean;
  onStatusChange: (status: string) => void;
}) {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  const { data: integrationMemoActives } = useIntegrationMemoActives({
    rfsId: id,
  });
  const integrationMemoActive = integrationMemoActives?.[0];

  useEffect(() => {
    if (integrationMemoActive) {
      onStatusChange(integrationMemoActive.status?.toLowerCase());
    }
  }, [integrationMemoActive, onStatusChange]);

  const { mutate, isPending } = useIntegrationMemoActiveCreate();

  const handleCreateMemo = () => {
    mutate(
      {
        id: id,
      },
      {
        onSuccess: (result) => {
          const originalData = result.data.original;
          if (originalData.status == "error") {
            swalError.fire({
              text: "Failed upload data Memo Active",
            });
          } else {
            swalSuccess.fire({
              text: "Successfully upload data Memo Active",
            });
          }
        },
        onError: (error) => {
          swalError.fire({
            text: error.message,
          });
        },
      },
    );
  };

  return (
    <ContainerPrimary>
      <div className="flex-grow whitespace-nowrap">
        <H5>
          Create Memo{" "}
          <span>
            (Last Update:{" "}
            {integrationMemoActive?.updatedDate
              ? formatDateTime(integrationMemoActive?.updatedDate)
              : "-"}
            )
          </span>
        </H5>
        <P>{integrationMemoActive?.noMemo ?? "-"}</P>
        <P>
          Date Memo Active:{" "}
          {integrationMemoActive?.dateMemoActive
            ? formatDateTime(integrationMemoActive?.dateMemoActive)
            : "-"}
        </P>
      </div>
      <ContainerSecondary>
        <P className="flex-grow text-axiata-blue dark:text-neutral-300">
          {convertUppercaseLabelToCapitalize(integrationMemoActive?.status)}
        </P>
        <SubmitButton
          onClick={handleCreateMemo}
          loading={isPending}
          className="ml-auto"
          disabled={
            isReadOnly ||
            !integrationMemoActive ||
            integrationMemoActive?.status?.toLowerCase() === "success"
          }
        >
          Create Memo
        </SubmitButton>
      </ContainerSecondary>
    </ContainerPrimary>
  );
}
